module.exports = __webpack_public_path__ + "img/calendar.23d94d23.png";